import { useGatesSurveyStore } from 'vue_features/gates_mep/composables/use_gates_survey_store'

export default function ({ state }) {
  useGatesSurveyStore().$set({
    surveys: state || [],
  })
  return {}
}
